<template>
  <div class="_boxBg_dark_yonggang absolute_center">
    <div class="selfClose_btn" @click="close()"></div>
    <div class="_boxTitle">实时环境数据</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="AQIcharts">
        <p class="dataRefresh_title">
          <span>数值单位：μg/m³(CO为mg/m³) &nbsp;&nbsp;&nbsp;&nbsp;数据更新时间：{{
            currentQuality.dayTime
          }}</span>
        </p>
        <div style="height: 160px;margin-bottom:10px">
          <div class="AQItitle_part1">
            <p class="factoryName">永钢厂区</p>
            <p :style="returnColor(currentQuality.aqi)" class="factoryQuality">
              <span class="bigTitle">{{ currentQuality.aqi }}</span>
              <span>{{ curAqiLevel }}</span>
            </p>
            <div class="colorArea">
              <div class="colorBar">
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <div class="colorContent">
                <p>0</p>
                <p>50<br />优</p>
                <p>100<br />良</p>
                <p>150<br />轻度</p>
                <p>200<br />中度</p>
                <p>300<br />重度</p>
                <p>≥500<br />严重</p>
              </div>
            </div>
          </div>
          <div class="AQItitle_part2">
            <div class="noxBar">
              <div :style="returnBG(currentQuality.pm25)" class="noxKey">PM2.5</div>
              <div class="noxVal">{{ currentQuality.pm25 }}</div>
            </div>
            <div class="noxBar">
              <div :style="returnBG(currentQuality.no2)" class="noxKey">NO2</div>
              <div class="noxVal">{{ currentQuality.no2 }}</div>
            </div>
            <div class="noxBar">
              <div :style="returnBG(currentQuality.co)" class="noxKey">CO</div>
              <div class="noxVal">{{ currentQuality.co }}</div>
            </div>
            <div class="noxBar">
              <div :style="returnBG(currentQuality.pm10)" class="noxKey">PM10</div>
              <div class="noxVal">{{ currentQuality.pm10 }}</div>
            </div>
            <div class="noxBar">
              <div :style="returnBG(currentQuality.so2)" class="noxKey">SO2</div>
              <div class="noxVal">{{ currentQuality.so2 }}</div>
            </div>
            <div class="noxBar">
              <div :style="returnBG(currentQuality.o3)" class="noxKey">O3</div>
              <div class="noxVal">{{ currentQuality.o3 }}</div>
            </div>
          </div>
          <div class="AQItitle_part3">
            <div class="monthly">
              <div class="legend">
                <p>
                  <span class="excellent">优&nbsp;&nbsp;</span>{{ monthlyPieStatics.excellentDays
                }}<span style="font-size: 12px">天</span>
                </p>
                <p>
                  <span class="good">良&nbsp;&nbsp;</span>{{ monthlyPieStatics.goodDays
                }}<span style="font-size: 12px">天</span>
                </p>
              </div>
              <div class="monthlyChart" ref="monthlyChart"></div>
              <div style="text-align: center; margin-top: -20px">
                <span class="chartTitle">{{ monthlyPieStatics.month }}月</span>
                <span class="chartContent">优良天气统计</span>
              </div>
            </div>
            <div class="yearly">
              <div class="legend">
                <p>
                  <span class="excellent">优&nbsp;&nbsp;</span>{{ yearlyPieStatics.excellentDays
                }}<span style="font-size: 12px">天</span>
                </p>
                <p>
                  <span class="good">良&nbsp;&nbsp;</span>{{ yearlyPieStatics.goodDays
                }}<span style="font-size: 12px">天</span>
                </p>
              </div>
              <div class="yearlyChart" ref="yearlyChart"></div>
              <div style="text-align: center; margin-top: -20px">
                <span class="chartTitle">{{ yearlyPieStatics.year }}</span>
                <span class="chartContent">优良天气统计</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="airQualityRank">
            <div class="airQualityRank_title">
              <span class="title_dot">●</span>
              <span class="title_content">空气质量</span>
              <span class="title_rank">排名</span>
              <el-table class="airQualityTable" :data="airQualityTableData" stripe style="width: 100%; margin-top: 10px" height="550px" :header-cell-class-name="getHeaderCellClass"
                :header-row-class-name="getHeadRowClass" :cell-class-name="getCellClass" :row-class-name="getRowClass" :row-style="{height: '36px'}">
                <el-table-column prop="city" label="城市" width="85px;"> </el-table-column>
                <el-table-column prop="currentAqi" label="当日AQI" width="100px;">
                </el-table-column>
                <el-table-column prop="quality" label="空气质量等级" width="120px">
                </el-table-column>
                <el-table-column prop="rankOfDay" label="当日排名"> </el-table-column>
                <el-table-column prop="rankOfMonth" label="当月排名"> </el-table-column>
                <el-table-column prop="rankOfYear" label="当年排名"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="airQualityIndex">
            <div class="airQualityIndex_title">
              <span class="title_dot">●</span>
              <span class="title_content">永钢</span>
              <span class="title_rank">今日</span>
              <span class="title_content">空气质量指数</span>
              <el-table class="airIndexTable" :data="airIndexTableData" stripe style="width: 100%; margin-top: 10px" height="550px" :header-cell-class-name="getHeaderCellClass"
                :header-row-class-name="getHeadRowClass" :cell-class-name="getCellClass" :row-class-name="getRowClass" :row-style="{height: '36px'}">
                <el-table-column prop="date" label="时间" width="55px;">
                  <template #default="scope">
                    {{ scope.row.dayTimeFormat }}
                  </template>
                </el-table-column>
                <el-table-column prop="aqi" label="AQI" width="55px;"> </el-table-column>
                <el-table-column prop="quality" label="空气质量等级">
                </el-table-column>
                <el-table-column prop="pollutions" label="首要污染物" width="100px">
                </el-table-column>
                <el-table-column prop="pm25" label="PM2.5" width="70px;"> </el-table-column>
                <el-table-column prop="pm10" label="PM10" width="66px;"> </el-table-column>
                <el-table-column prop="no2" label="NO2" width="66px;"> </el-table-column>
                <el-table-column prop="so2" label="SO2" width="66px;"> </el-table-column>
                <el-table-column prop="co" label="CO" width="66px;"> </el-table-column>
                <el-table-column prop="o3" label="O3" width="66px;"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="monthlyCompare">
            <div class="monthlyCompare_title">
              <span class="title_dot">●</span>
              <span class="title_rank">月度</span>
              <span class="title_content">优良天数对比统计</span>
              <div class="monthlyBar">
                <div class="monthlyLineChart" ref="monthlyLineChart"></div>
              </div>

              <span class="title_dot">●</span>
              <span class="title_rank">年度</span>
              <span class="title_content">优良天数对比统计</span>
              <div class="yearlyBar">
                <div class="yearlyLineChart" ref="yearlyLineChart"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { unwarp } from "@/utils/tools.js";

export default {
  name: "aqiDialog",
  title: "历史查询",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  data() {
    return {
      customerId: this.globalInstance.$store.state.customerId,
      airQualityTableData: [],
      airIndexTableData: [],
      aqiRankList: [],
      currentQuality: {},
      todayQuality: [],
      monthlyPieStatics: {
        excellentDays: 0,
        goodDays: 0,
        month: "--",
      },
      yearlyPieStatics: {
        excellentDays: 0,
        goodDays: 0,
        year: "--",
      },
      monthlyStatics: [],
      yearlyStatics: [],
      curAqiLevel: "",
    };
  },
  mounted() {
    this.getAqiRankList();

    this.getTodayHoursInfo();

    this.getYearAndMonthInfoThis();

    this.getAqiMonthStatistic();

    this.getAqiYearStatistic();
  },
  computed: {
    returnColor() {
      return function (val) {
        if (val < 50) {
          return {
            color: "#05fb10",
          };
        } else if (val < 100) {
          return {
            color: "#fff110",
          };
        } else if (val < 150) {
          return {
            color: "#f39800",
          };
        } else if (val < 200) {
          return {
            color: "#eb6100",
          };
        } else if (val < 300) {
          return {
            color: "#e60012",
          };
        } else if (val >= 300) {
          return {
            color: "#a40000",
          };
        } else {
          return {
            color: "none",
          };
        }
      };
    },
    returnBG() {
      return function (val) {
        if (val < 50) {
          return {
            background: "#05fb10",
          };
        } else if (val < 100) {
          return {
            background: "#fff110",
          };
        } else if (val < 150) {
          return {
            background: "#f39800",
          };
        } else if (val < 200) {
          return {
            background: "#eb6100",
          };
        } else if (val < 300) {
          return {
            background: "#e60012",
          };
        } else if (val >= 300) {
          return {
            background: "#a40000",
          };
        } else {
          return {
            color: "none",
          };
        }
      };
    },

    getHeaderCellClass() {
      return function (obj) {
        return "thClass";
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      return function (obj) {
        return "tdClass_";
      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },
  },
  beforeUnmount() {},
  methods: {
    async getAqiRankList() {
      let that = this;

      let aqi_rank_list =
        CONFIG.requestName + this.globalInstance.$apiOpt.aqi_rank_list;
      let res = await this.globalInstance.$apiUtils.get(aqi_rank_list);
      if (res && res.length) {
        that.airQualityTableData = res;
      }
    },
    async getTodayHoursInfo() {
      let that = this;
      // let res = await API.todayHoursInfo();
      let today_hours_info =
        CONFIG.requestName + this.globalInstance.$apiOpt.today_hours_info;
      let res = await this.globalInstance.$apiUtils.get(today_hours_info);
      if (res && res.todayAqiHoursInfoList.length) {
        that.airIndexTableData = res.todayAqiHoursInfoList
          ? res.todayAqiHoursInfoList
          : [];
        that.airIndexTableData.forEach((item) => {
          item.dayTimeFormat = moment(item.dayTime).format("hh");
        });
      }
      if (res && res.currentAqiInfo) {
        that.currentQuality = res.currentAqiInfo;
        that.curAqiLevel = res.currentAqiInfo.quality;
        that.currentQuality["dayTime"] = moment(
          that.currentQuality["dayTime"]
        ).format("YYYY-MM-DD hh:mm");
      }
    },
    async getYearAndMonthInfoThis() {
      let that = this;
      // let res = await API.yearandmonthInfoThis();
      let yearandmonth_info_this =
        CONFIG.requestName + this.globalInstance.$apiOpt.yearandmonth_info_this;
      let res = await this.globalInstance.$apiUtils.get(yearandmonth_info_this);
      try {
        if (res && res.aqiMonthStatisticResult) {
          if (res.aqiMonthStatisticResult.aqiStatisticInfoList.length > 0) {
            that.monthlyPieStatics.excellentDays =
              res.aqiMonthStatisticResult.aqiStatisticInfoList[0][
                "excellentDays"
              ];
            that.monthlyPieStatics.goodDays =
              res.aqiMonthStatisticResult.aqiStatisticInfoList[0]["goodDays"];
            that.monthlyPieStatics.month = res.aqiMonthStatisticResult.month;
          }
        }

        if (res && res.aqiYearStatisticResult) {
          if (res.aqiYearStatisticResult.aqiStatisticInfoList.length > 0) {
            that.yearlyPieStatics.excellentDays =
              res.aqiYearStatisticResult.aqiStatisticInfoList[0][
                "excellentDays"
              ];
            that.yearlyPieStatics.goodDays =
              res.aqiYearStatisticResult.aqiStatisticInfoList[0]["goodDays"];
            that.yearlyPieStatics.year = res.aqiYearStatisticResult.year;
          }
        }
      } catch (err) {
        that.monthlyPieStatics.excellentDays = 0;
        that.monthlyPieStatics.goodDays = 0;
        that.monthlyPieStatics.month = "--";

        that.yearlyPieStatics.excellentDays = 0;
        that.yearlyPieStatics.goodDays = 0;
        that.yearlyPieStatics.month = "--";
      }

      that.getMonthlyPieChart([
        that.monthlyPieStatics.excellentDays,
        that.monthlyPieStatics.goodDays,
      ]);

      that.getYearlyPieChart([
        that.yearlyPieStatics.excellentDays,
        that.yearlyPieStatics.goodDays,
      ]);
    },
    async getAqiMonthStatistic() {
      let that = this;
      let month = parseInt(moment(new Date()).format("MM"));
      // let res = await API.aqiMonthStatistic({ month: month });
      let aqi_month_statistic =
        CONFIG.requestName + this.globalInstance.$apiOpt.aqi_month_statistic;
      let res = await this.globalInstance.$apiUtils.get(aqi_month_statistic, {
        month: month,
      });
      if (res && res.aqiStatisticInfoList.length > 0) {
        let xlist = [],
          ylist = [],
          ylist_ = [];
        res.aqiStatisticInfoList.forEach((item, n) => {
          xlist.push(n % 2 == 0 ? item.name : "\n" + item.name);
          ylist.push(item.excellentDays);
          ylist_.push(item.goodDays);
        });
        that.getMonthlyLineChart(xlist, ylist, ylist_);
      }
    },
    async getAqiYearStatistic() {
      let that = this;
      let year = parseInt(moment(new Date()).format("YYYY"));
      // let res = await API.aqiYearStatistic({ year: year });
      let aqi_year_statistic =
        CONFIG.requestName + this.globalInstance.$apiOpt.aqi_year_statistic;
      let res = await this.globalInstance.$apiUtils.get(aqi_year_statistic, {
        year: year,
      });
      if (res && res.aqiStatisticInfoList.length > 0) {
        let xlist = [],
          ylist = [],
          ylist_ = [];
        res.aqiStatisticInfoList.forEach((item, n) => {
          xlist.push(n % 2 == 0 ? item.name : "\n" + item.name);
          ylist.push(item.excellentDays);
          ylist_.push(item.goodDays);
        });
        that.getYearlyLineChart(xlist, ylist, ylist_);
      }
    },

    getMonthlyPieChart(list) {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        legend: {
          top: "5%",
          left: "center",
          show: false,
        },
        series: [
          {
            name: "3",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 30,
                name: "",
                itemStyle: { color: "#14325B" },
              },
            ],
          },
          {
            name: "1",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: list[0] + list[1],
                name: "良",
                itemStyle: { color: "#fff110" },
              },
              {
                value: 30 - list[0] - list[1],
                name: "",
                itemStyle: { color: "#14325B00" },
              },
            ],
          },
          {
            name: "2",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: list[0],
                name: "优",
                itemStyle: { color: "#05fb10" },
              },
              {
                value: 30 - list[0],
                name: "",
                itemStyle: { color: "#14325B00" },
              },
            ],
          },
        ],
      };

      let monthly = this.$refs.monthlyChart;
      let myChart = monthly && echarts.init(monthly);
      option && unwarp(myChart).setOption(option);
    },
    getYearlyPieChart(list) {
      let that = this;
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        legend: {
          top: "5%",
          left: "center",
          show: false,
        },
        series: [
          {
            name: "6",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 365,
                name: "",
                itemStyle: { color: "#14325B" },
              },
            ],
          },
          {
            name: "4",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: list[0] + list[1],
                name: "良",
                itemStyle: { color: "#fff110" },
              },
              {
                value: 365 - list[0] - list[1],
                name: "",
                itemStyle: { color: "#14325B00" },
              },
            ],
          },
          {
            name: "5",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: list[0],
                name: "优",
                itemStyle: { color: "#05fb10" },
              },
              {
                value: 365 - list[0],
                name: "",
                itemStyle: { color: "#14325B00" },
              },
            ],
          },
        ],
      };

      let yearly = this.$refs.yearlyChart;
      let myChart = yearly && echarts.init(yearly);
      option && unwarp(myChart).setOption(option);
    },
    getMonthlyLineChart(listX, listY, listY_) {
      let dataX = listX;
      let dataY = listY;
      let option = {
        title: {
          text: "",
          subtext: "单位/天",
          subtextStyle: {
            color: "#ccc",
          },
        },
        legend: {
          data: ["优", "良"],
          textStyle: {
            color: "#ccc",
          },
        },
        xAxis: {
          data: dataX,
          axisLabel: {
            textStyle: {
              color: "#ccc",
              fontSize: "14px",
            },
            interval: 0,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
          splitNumber: 1,
          //axisLabel: { interval: 0 },
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(138, 144, 153, 0.4)",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            name: "优",
            showBackground: false,
            barGap: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#01fb09FF" },
                { offset: 0.3, color: "#01fb09FF" },
                { offset: 1, color: "#01fb0911" },
              ]),
            },
            label: {
              show: true,
              position: "top",
              color: "#ccc",
              fontSize: "16px",
            },
            data: dataY,
          },
          {
            type: "bar",
            name: "良",
            showBackground: false,
            barGap: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#FFF100FF" },
                { offset: 0.3, color: "#FFF100FF" },
                { offset: 1, color: "#FFF10011" },
              ]),
            },
            label: {
              show: true,
              position: "top",
              color: "#ccc",
              fontSize: "16px",
            },
            data: listY_,
          },
        ],
      };

      let monthlyLine = this.$refs.monthlyLineChart;
      let myChart = monthlyLine && echarts.init(monthlyLine);
      option && myChart.setOption(option);
    },
    getYearlyLineChart(listX, listY, listY_) {
      let dataX = listX;
      let dataY = listY;
      let option = {
        title: {
          text: "",
          subtext: "单位/天",
          subtextStyle: {
            color: "#ccc",
          },
        },
        legend: {
          data: ["优", "良"],
          textStyle: {
            color: "#ccc",
          },
        },
        xAxis: {
          data: dataX,
          axisLabel: {
            textStyle: {
              color: "#ccc",
              fontSize: "14px",
            },
            interval: 0,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
          splitNumber: 1,
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(138, 144, 153, 0.4)",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            name: "优",
            showBackground: false,
            barGap: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#01fb09FF" },
                { offset: 0.3, color: "#01fb09FF" },
                { offset: 1, color: "#01fb0911" },
              ]),
            },
            label: {
              show: true,
              position: "top",
              color: "#ccc",
              fontSize: "16px",
            },
            data: dataY,
          },
          {
            type: "bar",
            name: "良",
            showBackground: false,
            barGap: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#FFF100FF" },
                { offset: 0.3, color: "#FFF100FF" },
                { offset: 1, color: "#FFF10011" },
              ]),
            },
            label: {
              show: true,
              position: "top",
              color: "#ccc",
              fontSize: "16px",
            },
            data: listY_,
          },
        ],
      };

      let yearlyLine = this.$refs.yearlyLineChart;
      let myChart = yearlyLine && echarts.init(yearlyLine);
      option && myChart.setOption(option);
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped>
.airIndexTable th > .cell {
  font-size: 14px !important;
  color: #ccc !important;
}

.airIndexTable th {
  background: #043775 !important;
  border-top: 1px solid #05679c !important;
  padding: 5px 0 !important;
}

.airQualityTable th > .cell {
  font-size: 14px !important;
  color: #ccc !important;
}

.el-table tbody .cell {
  font-size: 14px !important;
  color: #90dcff !important;
}

.airQualityTable th {
  background: #043775 !important;
  border-top: 1px solid #05679c !important;
  padding: 5px 0 !important;
}

.dataRefresh_title {
  text-align: right;
  position: absolute;
  top: 10px;
  right: 20px;
  color: rgba(175, 175, 175, 1);
}

.AQItitle_part1 {
  width: 630px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: 100%;
}
.AQItitle_part1::after {
  content: "";
  width: 1px;
  display: block;
  top: 30px;
  right: -10px;
  position: absolute;
  height: 107px;
  background: #f5a623;
  box-shadow: 8px 8px 8px 0px #f5a623;
}

.AQItitle_part2 {
  width: 735px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: 100%;
  padding: 42px 100px 0;
}

.AQItitle_part2::after {
  content: "";
  width: 1px;
  display: block;
  top: 30px;
  right: -40px;
  position: absolute;
  height: 107px;
  background: #f5a623;
  box-shadow: 8px 8px 8px 0px #f5a623;
}

.AQItitle_part3 {
  width: 800px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: 100%;
}

.monthly {
  position: relative;
  display: inline-block;
  margin-left: 220px;
  .legend {
    position: absolute;
    top: 54px;
    left: 51px;
    .excellent {
      color: #05fb10;
    }
    .good {
      color: #fff110;
    }
  }
  .chartTitle {
    font-size: 18px;
    // font-weight: bold;
    color: rgba(71, 255, 221, 1);
  }
  .chartContent {
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
  }
  .monthlyChart {
    width: 150px;
    height: 150px;
    display: inline-block;
  }
}

.yearly {
  position: relative;
  display: inline-block;
  margin-left: 50px;
  .legend {
    position: absolute;
    top: 54px;
    left: 51px;
    .excellent {
      color: #05fb10;
    }
    .good {
      color: #fff110;
    }
  }
  .chartTitle {
    font-size: 18px;
    // font-weight: bold;
    color: rgba(71, 255, 221, 1);
  }
  .chartContent {
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
  }
  .yearlyChart {
    width: 150px;
    height: 150px;
    display: inline-block;
  }
}

.noxBar {
  width: 110px;
  display: inline-block;
  margin: 5px 20px;
  .noxKey {
    width: 50%;
    display: inline-block;
    text-align: center;
    height: 27px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-weight: bold;
    font-size: 22px;
    border: 1px solid #9ebdf6;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 27px;
  }
  .noxVal {
    width: 50%;
    display: inline-block;
    text-align: center;
    height: 27px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size: 22px;
    border: 1px solid #9ebdf6;
    font-size: 14px;
    font-weight: 400;
    color: rgba(175, 175, 175, 1);
    line-height: 27px;
  }
}

.factoryQuality {
  text-align: center;
  font:nth-child(1) {
    font-size: 48px;
    font-weight: bold;
    font-style: italic;
    margin-right: 10px;
  }
  font:nth-child(2) {
    font-size: 20px;
  }
}

.factoryName {
  letter-spacing: 3px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  line-height: 33px;
  text-shadow: 8px 8px 8px rgba(255, 255, 255, 0.5);
  margin-bottom: 10px;
}

.AQIcharts {
  pointer-events: auto;
  .colorBar {
    width: 390px;
    margin: auto;
    p {
      display: inline-block;
      width: 60px;
      height: 11px;
      border-right: 2px solid #ccc;
    }

    p:nth-child(1) {
      background: #05fb10;
    }
    p:nth-child(2) {
      background: #fff110;
    }
    p:nth-child(3) {
      background: #f39800;
    }
    p:nth-child(4) {
      background: #eb6100;
    }
    p:nth-child(5) {
      background: #e60012;
    }
    p:nth-child(6) {
      background: #a40000;
      border-right: none;
    }
  }

  .colorContent {
    width: 400px;
    margin: auto;
    p {
      display: inline-block;
      width: 56px;
      height: 11px;
      font-size: 14px;
      color: #fff;
    }
  }
}

.airQualityRank {
  margin-right: 30px;
  position: relative;
  width: 625px;
  height: 580px;
  display: inline-block;
  vertical-align: top;
  .airQualityRank_title {
    .title_dot {
      @include bg-box(22px, 22px, "potBg.png");
      display: inline-block;
      margin-right: 13px;
    }
    .title_content {
      color: rgba(215, 215, 215, 1);
      font-size: 18px;
      line-height: 40px;
      vertical-align: middle;
    }
    .title_rank {
      color: rgba(71, 255, 221, 1);
      font-size: 24px;
      line-height: 40px;
      // vertical-align: middle;
    }
  }
}

.airQualityIndex {
  position: relative;
  display: inline-block;
  width: 746px;
  height: 580px;
  vertical-align: top;
  .airQualityIndex_title {
    .title_dot {
      @include bg-box(22px, 22px, "potBg.png");
      display: inline-block;
      margin-right: 13px;
    }
    .title_content {
      color: rgba(215, 215, 215, 1);
      font-size: 18px;
      line-height: 40px;
      vertical-align: middle;
    }
    .title_rank {
      color: rgba(71, 255, 221, 1);
      font-size: 24px;
      line-height: 40px;
      // vertical-align: middle;
    }
  }
}

.monthlyCompare {
  position: relative;
  display: inline-block;
  width: 750px;
  height: 580px;
  margin-left: 20px;
  vertical-align: top;
  .monthlyCompare_title {
    margin-top: 30px;
    .title_dot {
      @include bg-box(22px, 22px, "potBg.png");
      display: inline-block;
      margin-right: 13px;
    }
    .title_content {
      color: rgba(215, 215, 215, 1);
      font-size: 18px;
      line-height: 40px;
      vertical-align: middle;
    }
    .title_rank {
      color: rgba(71, 255, 221, 1);
      font-size: 24px;
      line-height: 40px;
      // vertical-align: middle;
    }
    .monthlyBar {
      position: relative;
      width: 100%;
      height: 250px;
    }
    .monthlyLineChart {
      position: relative;
      height: 100%;
      width: 100%;
    }
    .yearlyBar {
      position: relative;
      width: 100%;
      height: 250px;
      margin-top: 20px;
    }
    .yearlyLineChart {
      position: relative;
      height: 100%;
      width: 100%;
    }
  }
}
._boxBg_dark_yonggang {
  width: 2450px;
  height: 995px;
  background: #000000;
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border-radius: 2px;
  position: absolute;
  pointer-events: all;
  z-index: 999;
  .selfClose_btn {
    top: 20px;
    right: 40px;
  }
  ._boxTitle {
    width: 100%;
    padding-left: 36px;
    height: 60px;
    font-size: 26px;
    font-weight: 500;
    color: #f5a623;
    line-height: 60px;
    border-bottom: 1px solid #492e00;
  }
  ._yellowLine {
    width: 350px;
    height: 4px;
    background: #ffad25;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    border-radius: 2px 2px 0px 0px;
  }
  ._innerBox {
    position: relative;
    margin: 60px 100px;
    height: 838px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%
    );
    border: 1px solid #8badff;
    padding: 35px;
  }
}
</style>
<style  lang="scss">
._boxBg_dark_yonggang {
  .airIndexTable,
  .airQualityTable {
    border: 1px solid #8badff !important;
    background: #01132d40 !important;
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
      padding: 8px 0px !important;
    }

    .thClass > .cell {
      font-size: 16px !important;
      color: #47ffddff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
    }
    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
      padding: 0 !important;
    }
    .tdClass > .cell {
      font-size: 16px !important;
      color: #e2e2e2 !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .tdClass_ {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #0b336b40 !important;
      padding: 0 !important;
    }

    .tdClass_ > .cell {
      font-size: 16px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .trClass {
      padding: 0 !important;
    }
    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
      height: 50px;
      background: rgba(1, 18, 43, 0.81);
      border: 1px solid rgba(132, 170, 255, 0.5);
      font-size: 16px;
      color: #47ffdd;
    }
  }
}
</style>